import styled from 'styled-components';

export const PostContentFromAdminPanelStyles = styled.div`
  display: grid;
  gap: 12px;
  
  max-width: 880px;
  
  ul, ol {
    display: grid;
    gap: 8px;
  }
  
  ul {
    li {
      position: relative;
      padding-left: 24px;
      
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0.5em;
        transform: translateY(-25%);
        border-radius: 100%;
        
        width: 12px;
        height: 12px;
        background: #FFC228;
      }
    }
  }
`;
